angular.module('impactx').controller('AppController', [
    '$scope',
    '$context',
    'dataGen',
    '$securityManager',
    'themeFactory',
    'LoginService',
    '$location',
    '$window',
    'TranslationService',
    'cfpLoadingBar',
    'CustomerService',
    'AngularAllMigrationService',
    'ixUpgradeService',
    '$workspace',
    function ($scope, $context, dataGen, $securityManager, themeFactory, 
        LoginService, $location, $window, TranslationService, cfpLoadingBar, 
        CustomerService,
        AngularAllMigrationService,
        ixUpgradeService, $workspace) {
        $scope.context = $context;
        $scope.requestInProgress = dataGen.requestInProgress;
        themeFactory.initializeTheming();
        this.customerServicePanel = CustomerService.data;
        this.getTheme = function () {
            return themeFactory.getTheme();
        };
        var currentLocation = $location.path();
        //no init on oci login. This will be done after.
        if ($context.needsInit() && currentLocation.indexOf("/ocilogin") !== 0 &&
            currentLocation.indexOf("/loginsaml") !== 0) {
            $context.init($scope, dataGen, $securityManager).then(function () {
                if (!$context.needsInit()) {
                    LoginService.refreshUI(false)
                }
            });
        }

        $window.onbeforeunload = function () {
            var formController = angular.element('#ix-main-view').find("form").controller("form");
            if (formController) {
                var showExitMessage = (!$context.isExitMessageDisabled && formController.$dirty) || $context.isExternalGuest.value;
                if (showExitMessage) {
                    return TranslationService.get('exitApplicationMessage');
                }
            }
        };

        $scope.$watch(function () {
            return cfpLoadingBar.status();
        }, function (newValue, oldValue) {
            if (newValue && !angular.equals(newValue, oldValue)) {
                if (newValue >= 0.99) {
                    cfpLoadingBar.set(0.05);
                }
            }
        });

        $scope.$back = function () {
            window.history.back();
        };
        this.$back = function () {
            window.history.back();
        };

        this.highContrastActive = function () {
            return $workspace.getHighContrastActive();
        };

        window.ixServicesUsedByAngularLoaded = ixUpgradeService.hasLoaded() && AngularAllMigrationService.hasLoadedServices();
    }
]);
